
import { mapState, mapActions } from "vuex";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timeList: [
        { value: "orders", label: "Orders" },
        { value: "item-wise-report", label: "Item-Wise Report" },
        { value: "summary-report", label: "Summary Report" },
        {
          value: "gst-filing-report",
          label: "GST Filing Report",
          isComingSoon: true
        }
      ],
      types: [
        { value: "paper", label: "Regular Printing" },
        { value: "kot", label: "Thermal Printing" }
      ],

      selectedItems: [],
      typeOfPrint: "paper"
    };
  },

  computed: {
    ...mapState("report", ["ordersLoading", "reportLoading"])
  },
  methods: {
    printAction() {
      this.$emit("print-action");
    }
  }
};
